<template>
	<core-layout-headline-with-tabs :tabs="tabs">
		{{
		$t("users")
		}}
	</core-layout-headline-with-tabs>
</template>

<script>
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs"
import { can } from "@/permissions/"

export default {
	components: { CoreLayoutHeadlineWithTabs },

	computed: {
		tabs() {
			const output = [
				{
					name: this.$t("overview"),
					to: {
						name: "UsersUpdate",
						params: { loginId: this.$route.params.loginId }
					}
				},
				{
					name: this.$t("inherited_logins"),
					to: {
						name: "UserInheritedLogins",
						params: { id: this.$route.params.loginId }
					}
				}
			]
			return output
		}
	}
}
</script>
